import type { SVGProps } from 'react';
const DawnFlagBJ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BJ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BJ_svg__a)">
      <g filter="url(#dawn-flag-BJ_svg__b)">
        <path
          fill="#F12641"
          fillRule="evenodd"
          d="M0 16h22V7.467H0z"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#dawn-flag-BJ_svg__c)">
        <path fill="#FFD648" fillRule="evenodd" d="M0 7.467h22V0H0z" clipRule="evenodd" />
      </g>
      <path fill="#17A668" fillRule="evenodd" d="M0 16h8.38V0H0z" clipRule="evenodd" />
    </g>
    <defs>
      <filter
        id="dawn-flag-BJ_svg__b"
        width={22}
        height={8.533}
        x={0}
        y={7.467}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_267" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_267" result="shape" />
      </filter>
      <filter
        id="dawn-flag-BJ_svg__c"
        width={22}
        height={7.467}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_267" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_267" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagBJ;
